import { useState, useMemo, useEffect } from 'react';
import Slider from 'react-slick';
import { ReviewModal, ReviewCardv2 } from 'components/reviews';
import { useWindowSize } from 'hooks';
import { useStore } from 'store';
import { isLogged } from 'services/commons/sessions';
import { ShowMore } from '../ShowMoreReviews';
import { getCarouselConfig } from './config';
import './style.scss';
import { Col, Row, Container } from 'react-bootstrap';
import { patchReview } from 'services/reviews/patchReview';
import { fetchReviews } from 'store/actions/reviews';


import { PROFILE_DATA } from 'constants/storage64';
import { decodeStorage, encodeStorage } from 'functions/storageBase64';


export const ReviewsCardsv2 = ({ trueSlide, showAddReview = false }) => {
  const [showFullReview, setShowFullReview] = useState(false);
  const [selectedReview, setSelectedReview] = useState({});
  const [, { isMobile }] = useWindowSize();
  const [listOfReviews] = useStore(({ reviews }) => reviews.listOfReviews);
  const { results = { list: [] } } = listOfReviews;

  const [likes, setLikes] = useState({}); 
  const [dislikes, setDislikes] = useState({}); 

  const [userProfileData] = useState(decodeStorage(PROFILE_DATA));
  const [myReviews, setMyReviews] = useState([]); // [id:true]

  const handleLikeDislike = (id, like) => {
    // actualizar likes y dislikes con validaciones de localStorage
    if (like && (myReviews[id] === undefined || ((myReviews[id]?.clicked_like === false) && myReviews[id]?.like===false)) ) {
      setLikes((prevLikes) => ({ ...prevLikes, [id]: true, }));
      patchReview({id , body : {like : true } })
    }
    if (!like &&  (myReviews[id] === undefined || ((myReviews[id]?.clicked_dislike === false) && myReviews[id]?.like===true)) ) {
      setDislikes((prevLikes) => ({ ...prevLikes, [id]: true, }));
      patchReview({id , body : {like : false } })
    }
    
    // control de click por localStorage
    // insertar en myReviews si no existe
    const clicked_dislike = (myReviews[id] && myReviews[id].clicked_dislike) ? myReviews[id].clicked_dislike : false;
    const clicked_like = (myReviews[id] && myReviews[id].clicked_like) ? myReviews[id].clicked_like : false;
    myReviews[id] = {like, clicked_dislike:((!clicked_dislike)?!like:clicked_dislike), clicked_like:(!clicked_like)?like:clicked_like};
    setMyReviews(myReviews);
    encodeStorage(PROFILE_DATA, {...userProfileData, reviews: myReviews});
    // control de click por localStorage
  };
  

  const reverseResults = useMemo(
    () =>
      results.list
        .slice(0)
        .map((card, i) => ({
          ...card,
          persistId: i + 1,
          likes: likes[card.id] ? card.likes + 1 : card.likes, 
          dislikes : dislikes[card.id] ? card.dislikes + 1 : card.dislikes
      })),
    [results.list, likes, dislikes]
  );

  const handleClickCard = (card = {}) => {
    setShowFullReview(true);
    setSelectedReview(card);
  };

  const handleClose = () => setShowFullReview(false);

  useEffect(() => {
      // precarga de likes y dislikes (solo se ejecuta una vez)
      if (userProfileData?.reviews === undefined) {
        encodeStorage(PROFILE_DATA, {...userProfileData, reviews: {}});
      }else{
        setMyReviews(Object.keys(userProfileData?.reviews).reduce((acc, key) => {
          acc[key] = {like: userProfileData?.reviews[key].like, clicked_dislike: false, clicked_like: false};
          return acc;
        }
        , {}));
        console.clear();
        console.log('userProfileData?.reviews', userProfileData?.reviews);
        console.log('myReviews', myReviews);
      }
      // encodeStorage(PROFILE_DATA, {...userProfileData, reviews: {}}); // para borrar reviews, solo en pruebas
  }, []);

  return (
    <>
      <Container className="fixed-height-container">
        <Row>
          <div >
            {reverseResults.map((card) => (
              <>
              <div
                key={card.persistId}
                className="col-auto p-0 d-flex justify-content-center"
              >
                <ReviewCardv2
                  {...card}
                  onClick={() => handleClickCard(card)}
                  className={`${isMobile ? 'border-0' : ''}`}
                />
              
              </div>
              <div className="container-like">
                
                <span >{card._date_created}</span>
                <button
                  onClick={isLogged() ? () => handleLikeDislike(card.id, true): null}
                  className="fa fa-thumbs-up custom-like-button"
                  style={{ 
                    cursor: isLogged() ? 'pointer;' : 'default;', 
                    // color: ((myReviews[card.id]?.like === true) ? '#28a745' : 'gray')
                  }}
                  
                ></button>
                <span >{card.likes}</span>
                <button
                  onClick={isLogged() ? () => handleLikeDislike(card.id, false): null}
                  className="fa fa-thumbs-down custom-like-button"
                  style={{ 
                    cursor: isLogged() ? 'pointer' : 'default', 
                    // color: ((myReviews[card.id]?.like === false) ? '#dc3545' : 'gray') 
                    }}
                ></button>
                <span >{card.dislikes}</span>
                <hr />
              </div>
              </>
            ))}
          </div>
        </Row>
        <Row>
          <ReviewModal
            show={showFullReview}
            onClose={handleClose}
            {...selectedReview}
          />
        </Row>
        <Row>
          {isLogged() && showAddReview && (
            <div className="row m-auto AddNewReview">
              <div className="offset-md-6 offset-xl-8 col-md-6 col-xl-4 p-0 d-flex justify-content-center">
                {
                  isMobile ? (
                    <ShowMore className="m-auto" />
                  ) : (
                    <ReviewCardv2 className="border-0 AddNewReviewContainer">
                      <ShowMore className="m-auto" />
                    </ReviewCardv2>
                  )
                }
              </div>
            </div>
          )}
        </Row>
      </Container>
    </>
  );
};
